<template>
  <div class="c-error">
    <c-text-field
      :value="value"
      :rules="rules"
      v-bind="$attrs"
      :error-message="message" />
  </div>
</template>

<script>
export default {
  name: 'CError',
  props: {
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      required: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.c-error {
  ::v-deep .v-input__slot {
    display: none;
  }
  ::v-deep .v-text-field {
    padding-top: 0;
  }
}
</style>
